import React from 'react';
import { useHistory } from "react-router-dom";
import { Formik, useField } from "formik";
import * as Yup from "yup";
import { Button, Modal } from 'react-bootstrap';
import { getAPI } from '../GdacsAPI';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { useViewPort } from '../Hooks/useViewPort';
import { GdacsTimeline } from '../Layout/GdacsTimeline';

const UsernamePassword = (props) => {
    const params = props.params;
    const [responseMessage, setResponseMessage] = React.useState("");
    const [responseModal, setResponseModal] = React.useState("");
    const [user, setUser] = React.useState({ username: "", password: "" });
    const [isModified, setIsModified] = React.useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
    const [show, setShow] = React.useState(false);
    const initDataObject = {
        idUser: params?.idUser ? params.idUser : 0, username: params?.username, password: params?.password, firstName: params?.firstName, lastName: params?.lastName, email: params?.email, country: params?.country, organisation: params?.organisation, orgtype: params?.orgtype,
        emailOption: params?.emailOption, notes: params?.notes, enabled: params?.enabled, status: params?.status,
    }
    const [data, setData] = React.useState(initDataObject);
    const [pendingUser, setPendingUser] = React.useState(null);
    const history = useHistory();
    const { width } = useViewPort();
    const breakpoint = 620;

    const handleChangeCustom = (event) => {
        const obj = { ...user };
        obj[event.target.name] = event.target.value;
        setUser(obj);
    }

    const checkValidation = Yup.object().shape({
        username: Yup.string().email().required("Please insert a valid username account"),
        confirm_username: Yup.string().email().required("Please insert confirm username account").oneOf([Yup.ref("username")], "Username's not match"),
        password: Yup.string().required("No password provided.").min(8, "Password is too short - should be 8 chars minimum.").matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@_#$%^&*~.-]).{8,}$/,
            "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character (!@_#$%.-&* ~)."),
        confirm_password: Yup.string().required("No password provided.").min(8, "Password is too short - should be 8 chars minimum.").matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@_#$%^&*~.-]).{8,}$/,
            "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character (!@_#$%.-&* ~)."
        ).oneOf([Yup.ref("password")], "Password's not match").required("Required!")
    })

    const handleClose = () => {
        setShow(false);

        if (pendingUser) {
            history.push("/EditProfile", pendingUser);
        }
    }


    const handleCheckConditions = () => {
        setIsButtonDisabled(!isButtonDisabled);
    }

    async function checkUser(user) {
        const response = await fetch(getAPI() + `api/register/Users/checkusername?username=${user.username}`)
        const resp = await response.json();
        if (!response.ok) {
            setResponseMessage(resp.message);
            return;
        }
        else {
            if (resp.result === true) {
                setResponseModal("Your account has already exist, please check value and submit again.");
                setShow(true);
            }
            else {
                setResponseModal(
                    "Your username and password have been validated. You will shortly receive an OTP code via email to enter before completing the registration."
                );

                setShow(true);
                setPendingUser(user);
            }
        }
    }

    const handleFormikSubmit = (values, { setSubmitting }) => {
        setSubmitting(false);
        checkUser(values);
    }

    return (
        <Formik
            initialValues={initDataObject}
            validationSchema={checkValidation}
            onSubmit={handleFormikSubmit}
        >
            {({
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit
            }) => (
                <div className="alerts_container col-12">
                    <br />
                    <br />
                    <form onSubmit={handleSubmit}>
                        <h4 className="d-flex justify-content-center hr-title">Register Username  & Password</h4>
                        <br />
                        {width > breakpoint &&
                            <GdacsTimeline navIndex={1} user={0} />
                        }
                        {
                            width < breakpoint &&
                            <ProgressBar variant={"YOU_PICK_A_NAME"} now={20} label={1} />
                        }
                        <br />
                        <div className="p_summary">Password: minimum 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character (!@_#$%.-&* ~).</div>
                        <br />
                        <div>
                            <label className="label-user" htmlFor="username">Username</label>
                            <input className="form-control form-control-sm"
                                type="email"
                                name="username"
                                value={values.username}
                                onChange={e => {
                                    handleChange(e);
                                    handleChangeCustom(e);
                                }}
                                onBlur={handleBlur}
                            />
                            {errors.username && touched.username && (
                                <div className="input-feedback">{errors.username}</div>
                            )}
                        </div>
                        <div>
                            <label className="label-user">Confirm Username</label>
                            <input className="form-control form-control-sm"
                                type="email"
                                name="confirm_username"
                                value={values.confirm_username}
                                onChange={e => {
                                    handleChange(e);
                                    handleChangeCustom(e);
                                }}
                                onBlur={handleBlur}
                            />
                            {errors.confirm_username && touched.confirm_username && (
                                <div className="input-feedback">{errors.confirm_username}</div>
                            )}
                        </div>
                        <div>
                            <label className="label-user">Password</label>
                            <input className="form-control form-control-sm"
                                type="password"
                                name="password"
                                value={values.password}
                                onChange={e => {
                                    handleChange(e);
                                    handleChangeCustom(e);
                                }}
                                onBlur={handleBlur}
                            />
                            {errors.password && touched.password && (
                                <div className="input-feedback">{errors.password}</div>
                            )}
                        </div>
                        <div>
                            <label className="label-user">Confirm Password</label>
                            <input className="form-control form-control-sm"
                                type="password"
                                name="confirm_password"
                                value={values.confirm_password}
                                onChange={e => {
                                    handleChange(e);
                                    handleChangeCustom(e);
                                }}
                                onBlur={handleBlur}
                            />
                            {errors.confirm_password && touched.confirm_password && (
                                <div className="input-feedback">{errors.confirm_password}</div>
                            )}
                        </div>
                        <br />
                        {responseMessage &&
                            <div className="input-feedback">{responseMessage}</div>
                        }
                        {
                            width > breakpoint &&
                            <div className="col-12 row" style={{ flexWrap: "nowrap", paddingRight: "0px" }}>
                                <div className="col-11 row">
                                    <input type='checkbox' aria-label="Checkbox for following text input" onClick={handleCheckConditions} style={{ maxWidth: "20px", marginLeft: "10px", marginTop: "5px" }} /> &nbsp;
                                    <label style={{ fontSize: "14px", maxWidth: "600px" }}>    Your data will not be archived until the insertion procedure is complete</label>
                                </div>
                                <button type="button" className="float-right btn btn-primary" onClick={handleSubmit} disabled={isButtonDisabled}>
                                    Confirm
                                </button>
                            </div>
                        }
                        {
                            width < breakpoint &&
                            <>
                                <div className="col-12 row" style={{ flexWrap: "nowrap", paddingRight: "0px" }}>
                                    <input type='checkbox' aria-label="Checkbox for following text input" onClick={handleCheckConditions} style={{ maxWidth: "20px", marginLeft: "10px", marginTop: "5px" }} /> &nbsp;
                                    <label style={{ fontSize: "14px", maxWidth: "-moz-fit-content" }}>    Your data will not be archived until the insertion procedure is complete</label>
                                </div>
                                <br />
                                <button type="button" className="float-right btn btn-primary" onClick={handleSubmit} disabled={isButtonDisabled}>
                                    Confirm
                                </button>
                            </>
                        }
                        <Modal className="d-flex justify-content-left" show={show} onHide={handleClose}>
                            <Modal.Header closeButton>
                                <Modal.Title>User Account</Modal.Title>
                            </Modal.Header>
                            <><Modal.Body>{responseModal}</Modal.Body>
                                <Modal.Footer>
                                    <Button variant="primary" onClick={handleClose}>
                                        OK
                                    </Button>
                                </Modal.Footer></>
                        </Modal>
                        <br />
                        <br />
                    </form>
                    <br />
                    <br />
                </div>
            )}
        </Formik>
    );
}

export { UsernamePassword }